<button type="button" class="btn px-2 shadow-sm" [ngClass]="outline ? styles[type]?.classOutline : styles[type]?.class" (click)="click()" [disabled]="disabled" [hidden]="hidden">
  @if (!loading) {
    <i class="{{ icon ? icon : styles[type]?.icon }}"></i>
  }
  @if (loading) {
    <i class="fas fa-spinner fa-spin"></i>
  }
  @if (!onlyIcon) {
    <span> {{ (label ? label : styles[type]?.label) | translate }} </span>
  }
</button>